import React, { useEffect, useState } from "react";
import './style.scss';
import { Checkbox, Radio } from "antd";
import ButtonRoaming from "../component/ButtonRoaming/ButtonRoaming";
import { FILTER_PRICE } from "../constant/contanst";

const FilterTimePrice = ({ listCycle, initialFilter, onReset, onConfirm }) => {
  const [selectedCycles, setSelectedCycles] = useState(initialFilter.cycles);
  const [selectedPrice, setSelectedPrice] = useState(initialFilter.price);
  
  useEffect(() => {
    setSelectedCycles(initialFilter.cycles);
    setSelectedPrice(initialFilter.price);
  }, [initialFilter]);

  // const toggleCycleSelection = (cycle) => {
  //   setSelectedCycles((prev) => {
  //     const newSet = new Set(prev);
  //     if (newSet.has(cycle)) {
  //       newSet.delete(cycle);
  //     } else {
  //       newSet.add(cycle);
  //     }
  //     return newSet;
  //   });
  // };

  const handleReset = () => {
    setSelectedCycles([]);
    setSelectedPrice(null);
    onReset()
  }
  
  const onChangeCheckbox = (checkedValues) => {
    setSelectedCycles(checkedValues);
  };

  return (
    <div className="container-time-price">
      <div className="title-filter-time-price">Bộ lọc</div>
      <div className="wrapper-time-price">
        <div className="group">
          <div className="letter">Chu kỳ</div>
          <ul className="list">
            <Checkbox.Group
              className="checkbox-gr-time-price"
              options={listCycle?.map(e => ({label: e.cycleDesc, value: e.cycle}))} 
              onChange={onChangeCheckbox}
              value={selectedCycles}
            />
          </ul>
        </div>

        <div className="group">
          <div className="letter">Giá tiền</div>
          <Radio.Group 
            className="radio-gr-time-price"
            onChange={(e) => setSelectedPrice(e.target.value)}
            value={selectedPrice}
          >
            {FILTER_PRICE.map((e) => (
              <Radio key={e.value} value={e.value}>{e.label}</Radio>
            ))}
          </Radio.Group>
        </div>

        <div className="btn-filter-time-price">
          <ButtonRoaming className="border-primay" onClick={handleReset}>
            Xóa bộ lọc
          </ButtonRoaming>
          <ButtonRoaming className="primary" onClick={() => onConfirm({ cycles: selectedCycles, price: selectedPrice })}>
            Xác nhận
          </ButtonRoaming>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FilterTimePrice);
